export const SET_ALERT_STATUS = 'advaice/alertUI/SET_ALERT_STATUS';
export const SET_ALERT_SUCCES = 'advaice/alertUI/SET_ALERT_SUCCES';
export const SET_ALERT_WARNING = 'advaice/alertUI/SET_ALERT_WARNING';
export const SET_ALERT_ERROR = 'advaice/alertUI/SET_ALERT_ERROR';

const initialState = {
  alertPopup: {
    messageAlert: '',
    typeAlert: 0,
    statusAlert: false,
  },
};

export const alertStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ALERT_STATUS: {
      return {
        ...state,
        alertPopup: {
          statusAlert: action.payload,
          typeAlert: 0,
          messageAlert: '',
        },
      };
    }
    case SET_ALERT_ERROR: {
      return {
        ...state,
        alertPopup: {
          messageAlert: action.payload,
          typeAlert: 3,
          statusAlert: true,
        },
      };
    }
    case SET_ALERT_WARNING: {
      return {
        ...state,
        alertPopup: {
          messageAlert: action.payload,
          typeAlert: 2,
          statusAlert: true,
        },
      };
    }
    case SET_ALERT_SUCCES: {
      return {
        ...state,
        alertPopup: {
          messageAlert: action.payload,
          typeAlert: 1,
          statusAlert: true,
        },
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export const setAlertStatus = data => ({ type: SET_ALERT_STATUS, payload: data });
export const fetchAlertSuccess = data => ({ type: SET_ALERT_SUCCES, payload: data });
export const fetchAlertWarning = data => ({ type: SET_ALERT_WARNING, payload: data });
export const fetchAlertError = data => ({ type: SET_ALERT_ERROR, payload: data });



// WEBPACK FOOTER //
// ./src/reducers/alert-ui/duck.js